import { render, staticRenderFns } from "./OfferList.vue?vue&type=template&id=f2f9556e&scoped=true"
import script from "./OfferList.vue?vue&type=script&lang=js"
export * from "./OfferList.vue?vue&type=script&lang=js"
import style0 from "./OfferList.vue?vue&type=style&index=0&id=f2f9556e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f9556e",
  null
  
)

export default component.exports